'use client'

import { Note } from '@vinted/web-ui'
import { v4 as uuid } from 'uuid'

import { setSessionStorageItem, useLocation } from '@marketplace-web/shared/browser'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { urlWithParams } from '@marketplace-web/shared/utils'
import { REPORT_SESSION_ID_KEY } from '@marketplace-web/domain/admin-alerts-data'

import { NEW_ADMIN_ALERT_URL } from 'constants/routes'
import { Screen } from 'constants/tracking/screens'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { clickEvent } from '_libs/common/event-tracker/events'

import { AlertType } from '../../../constants/admin'

type Props = {
  conversationId: string | number | undefined
}

const ReportSuggestion = ({ conversationId }: Props) => {
  const translate = useTranslate()
  const { relativeUrl } = useLocation()
  const { track } = useTracking()

  const reportUrl = urlWithParams(NEW_ADMIN_ALERT_URL, {
    ref_id: conversationId,
    ref_type: AlertType.Conversation,
    ref_url: relativeUrl,
  })

  const handleReportClick = () => {
    setSessionStorageItem(REPORT_SESSION_ID_KEY, uuid())

    track(
      clickEvent({
        screen: Screen.ConversationList,
        target: ClickableElement.ReportConversation,
        targetDetails: String(conversationId),
      }),
    )
  }

  const reportText = translate('conversation.report_suggestion.text', {
    'report-link': chunks => (
      <a key="report-link" href={reportUrl} onClick={handleReportClick}>
        {chunks}
      </a>
    ),
  })

  return <Note text={reportText} alignment={Note.Alignment.Center} styling={Note.Styling.Wide} />
}

export default ReportSuggestion
